export default function QuizzyLogo({ size = 40 }) {
  return (
    <img
      src="/assets/logo.png"
      alt="Quizzy logo"
      className="shrink-0"
      style={{
        width: size,
        height: size,
        filter: "drop-shadow(0 0 12px rgba(138,43,226,0.55)) drop-shadow(0 0 26px rgba(0,240,255,0.18))",
      }}
    />
  );
}
